import { CancelRounded } from "@mui/icons-material";
import { Grid, IconButton } from "@mui/material";
import AcxMainTextField from "components/UI/AcxMainTextField";
import { LLMResultDefinition } from "models/LLMs";
import { useState } from "react";
import { useStandardConfigurationBuilder } from "../LLMConfigurationBuilderContext";
import React from "react";

type LLMResultDefinitionExampleProps = {
    llmResultDefinition: LLMResultDefinition;
    example: string;
    idx: number;
};

export function ResultDefinitionExample(
    props: LLMResultDefinitionExampleProps,
) {
    const builder = useStandardConfigurationBuilder();
    const [hovered, setHovered] = useState(false);

    return (
        <Grid
            container
            item
            columnGap={1}
            alignItems="flex-end"
            width="100%"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <Grid item flexGrow={1}>
                <AcxMainTextField
                    id={`result-${props.llmResultDefinition.result}-example-${props.idx}`}
                    placeholderText="Enter example in plain text..."
                    labelText="Example"
                    fullWidth
                    value={props.example}
                    onChange={(event) =>
                        builder.updateExample(
                            props.llmResultDefinition,
                            props.idx,
                            event.target.value,
                        )
                    }
                />
            </Grid>
            {hovered && props.idx > 0 && (
                <Grid item>
                    <IconButton
                        size="small"
                        onClick={() =>
                            builder.removeExample(
                                props.llmResultDefinition,
                                props.idx,
                            )
                        }
                    >
                        <CancelRounded fontSize="small" />
                    </IconButton>
                </Grid>
            )}
        </Grid>
    );
}
